module.exports = __webpack_public_path__ + "static/mat1610_compilado-eb2e7515949b2e27df640c2ddc9b8070.pdf";